
import { observer } from 'mobx-react-lite';
import { Form, Input, Button, message, Select } from 'antd';
import './index.scss';
import { http } from '../../utils';
import md5 from 'js-md5';

// user observer component observe the mobox data
const Manage = observer(() => {
  const [form] = Form.useForm();
  
  const validatePasswordConfirm = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('passwd') === value) {
        return Promise.resolve(); // 密码一致，校验通过
      }
      return Promise.reject('The passwords entered twice are inconsistent.'); 
    }
  });
  
  const onFinish = async (values) => {
    const { passwd, username, role, userEmail } = values;
    let passwdMd5 = md5(md5(passwd + 'twy-service'));
    
    const res = await http.post(`/api/user/add`, {
      passwd: passwdMd5,
      role,
      username,
      userEmail
    });
    
    const { code } = res;
    
    if (parseInt(code, 10) === 0) {
      message.success('add success');
      form.resetFields();
    } else {
      if (code === '-1') {
        message.error(res['message']);
      } else {
        message.error('add error');
      }
    }
  }
  
  return (
    <div>
      <div className="setting-header">Manage</div>
      <Form
        form={form}
        labelCol={{
          span: 3,
        }}
        onFinish={ onFinish }
      >
        <Form.Item
          label="UserName"
          name="username"
          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
            {
              max: 16, // 最大字符长度为50
              message: 'password length cannot exceed 16 characters',
            },
            {
              min: 8, // 最小字符长度为5
              message: 'password length cannot be less than 8 characters',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="userEmail"
          rules={[
            {
              required: true,
              message: 'Please input your email!',
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="passwd"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
            {
              max: 16, // 最大字符长度为50
              message: 'password length cannot exceed 16 characters',
            },
            {
              min: 8, // 最小字符长度为5
              message: 'password length cannot be less than 8 characters',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        
        <Form.Item
          label="Password comfirm"
          name="passwd2"
          rules={[
            {
              required: true,
              message: 'Please input your password comfirm!',
            },
            validatePasswordConfirm
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Role"
          name="role"
        >
          <Select>
            <Select.Option value="0">Admin</Select.Option>
            <Select.Option value="1">User</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 3,
          }}
        >
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
})

export default Manage;